import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import LocationSearch from './components/LocationSearch';
import store from './store';
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueScrollTo from 'vue-scrollto';
import SvgSprite from 'vue-svg-sprite';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const config = window.winebowLocatorConfig ? window.winebowLocatorConfig : { assetPath: '' };

Vue.use(Loading);
Vue.use(VueScrollTo);
Vue.use(SvgSprite, {
  url: './assets/sprite.svg',
  class: 'locator-icon',
});
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleMapsKey,
    libraries: 'places'
  }
});

Vue.config.productionTip = false;

Vue.component('GmapCluster', GmapCluster);
Vue.component('v-select', vSelect);
document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('location-search');
  if (!el) {
    return
  }
  /* eslint-disable no-new */
  new Vue({
    el: '#location-search',
    template: '<LocationSearch />',
    components: {
      LocationSearch
    },
    store
  })
});
